import { TableDataRowProps } from "../../../../../Common/UI/Index";
import { ICodeListItem } from "../../interfaces";

export const mapCodeListToTableRows = (data: ICodeListItem[]): TableDataRowProps[] => {
  return data.filter(item => item.countIncluded > 0).map(item => {
    const executionRow: TableDataRowProps = {
      row: [
        { value: item.term, propertyName: "term" },
        { value: item.conceptId, propertyName: "conceptId" },
        { value: item.countIncluded.toString(), propertyName: "countInc" }
      ]
    };

    return executionRow;
  });
};

export const tableHeader = [
  {
    title: "ResultDetails.CodeList.Term",
    propertyName: "term",
    width: "60%",
    sortable: false
  },
  {
    title: "ResultDetails.CodeList.ConceptId",
    propertyName: "conceptId",
    width: "20%",
    sortable: false
  },
  {
    title: "ResultDetails.CodeList.CountIncluded",
    propertyName: "countInc",
    width: "20%",
    sortable: false
  }
];

export const translateCodeListKeys = (codeList: ICodeListItem, t: (key: string) => string): string[] => {
  const headersKeys = Object.keys(codeList);
  const transformedKeys = headersKeys.map(key => key.charAt(0).toUpperCase() + key.slice(1));

  return transformedKeys.map(i => t(`ResultDetails.CodeList.${i}`));
};
